import React from "react";

export default function RgpdPage() {
  return (
    <section className="mt-8 flex justify-center">
      <div className="lg:w-1/2 w-full p-4 lg:p-0">
        <h1 className="text-center text-3xl mb-8">
          Politique de confidentialité
        </h1>
        <p className="mb-4">
          Influx est une application mobile destinée à mettre en relation les
          influenceurs et les entreprises dans le but de faire des partenariats.
          Nous prenons très au sérieux la protection de vos données personnelles
          et sommes engagés à respecter votre vie privée.
        </p>
        <h2 className="text-md font-bold">Collecte des données</h2>
        <p className="mb-4">
          Nous collectons les informations nécessaires pour alimenter les
          profils des utilisateurs afin de permettre le bon fonctionnement du
          service. Cela peut inclure des informations telles que votre nom,
          adresse e-mail, informations de profil et photos.
        </p>
        <h2 className="text-md font-bold">Utilisation des données</h2>
        <p className="mb-4">
          Nous utilisons les informations collectées uniquement pour le bon
          fonctionnement de notre service. Nous ne revendons pas ni ne
          transmettons à un tiers vos données personnelles.
        </p>
        <h2 className="text-md font-bold">Sécurité des données</h2>
        <p className="mb-4">
          Nous prenons les mesures de sécurité appropriées pour protéger vos
          informations personnelles contre la perte, l'utilisation abusive ou la
          modification non autorisée.
        </p>
        <h2 className="text-md font-bold">Partage des données</h2>
        <p className="mb-4">
          Nous ne partagerons pas vos informations personnelles avec des tiers,
          sauf en cas de demande de la part des autorités judiciaires ou si cela
          est nécessaire pour respecter nos Conditions Générales d'Utilisation.
        </p>
        <h2 className="text-md font-bold">
          Accès et modification de vos informations
        </h2>
        <p className="mb-4">
          Vous pouvez accéder à vos informations personnelles à tout moment et
          les mettre à jour via les paramètres de votre compte.
        </p>
        <h2 className="text-md font-bold">
          Mise à jour de la politique de confidentialité
        </h2>
        <p className="mb-4">
          Nous nous réservons le droit de mettre à jour cette politique de
          confidentialité à tout moment pour refléter les modifications
          apportées à notre service ou pour respecter les nouvelles lois et
          réglementations.
        </p>
      </div>
    </section>
  );
}
